(function IIFE() {
    'use strict';

    /////////////////////////////

    function EmailFactory($resource, Config) {
        'ngInject';

        return $resource(Config.HAUSSMANN_HOST + '/_ah/api/lumsites/v1/email/:methodKey', {}, {
            send: {
                isArray: false,
                method: 'POST',
                params: {
                    methodKey: 'send',
                },
            },
        });
    }

    /////////////////////////////

    angular.module('Factories').factory('EmailFactory', EmailFactory);
})();
